module.exports = __webpack_public_path__ + "static/media/kz.e08cb0b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/kz.svg
// module id = 170
// module chunks = 0